module.exports = __webpack_public_path__ + "img/fluent_cart-24-regular.2e713e46.png";